export default {
  cards: function (state) { return state.cards.data },
  cardsMeta: function (state) { return state.cards.meta },
  currentCard: function (state) { return state.card },
  tabs: function (state) { return state.tabs },
  selectedTab: function (state) { return state.selectedTab },
  selectedField: function (state) { return state.selectedField },
  availableFields: function (state) { return state.availableFields },
  previewGroupId: function (state) { return state.previewGroupId },
  isDirty: function (state) { return state.isDirty },
  isLoading: function (state) { return state.isLoading },

  // Tabs ordenadas
  sortedTabs: function (state) {
    var tabs = state.tabs.slice()
    return tabs.sort(function (a, b) { return a.order - b.order })
  },

  // Campos de uma tab específica
  fieldsByTab: function (state) {
    return function (tabId) {
      var tab = state.tabs.find(function (t) { return t.id === tabId })
      if (tab && tab.fields) {
        return tab.fields
      }
      return []
    }
  },

  // Campos ordenados de uma tab
  sortedFieldsByTab: function (state) {
    return function (tabId) {
      var tab = state.tabs.find(function (t) { return t.id === tabId })
      if (!tab || !tab.fields) return []
      var fields = tab.fields.slice()
      return fields.sort(function (a, b) { return a.order - b.order })
    }
  },

  // Total de campos na card
  totalFields: function (state) {
    return state.tabs.reduce(function (total, tab) {
      var fieldCount = tab.fields ? tab.fields.length : 0
      return total + fieldCount
    }, 0)
  },

  // Verifica se tem mudanças não salvas
  hasUnsavedChanges: function (state) { return state.isDirty }
}
